// Primary 2 Chinese Data - Part 1
// Based on Primary Chinese P2 Topics.txt

export const p2DataPart1 = {
  title: "小學二年級中文學習",
  description: "專為小學二年級學生設計的中文學習內容，進一步提升語文能力和寫作技巧",
  objectives: "提升語文運用能力，培養寫作思維，掌握更複雜的語法結構",
  focus: "重點學習人稱代詞、多義詞、直述句等進階語法，以及更豐富的文體閱讀理解",
  
  readingTypes: [
    "記人", "日記", "童話故事", "道歉卡", "寓言故事", "電影",
    "記事", "說明事物", "描寫動物", "描寫人物", "書信", "描寫植物"
  ],
  
  languageUsage: [
    {
      title: "人稱代詞",
      description: "學習人稱代詞的用法，掌握代詞的語法功能",
      sampleQuestions: [
        {
          question: "選擇正確的人稱代詞：（ ）喜歡讀書",
          answer: "我",
          explanation: "『我』是第一人稱代詞，表示說話者自己。"
        },
        {
          question: "選擇正確的人稱代詞：（ ）喜歡畫畫",
          answer: "你",
          explanation: "『你』是第二人稱代詞，表示聽話者。"
        },
        {
          question: "選擇正確的人稱代詞：（ ）很聰明",
          answer: "他",
          explanation: "『他』是第三人稱代詞，表示男性。"
        },
        {
          question: "選擇正確的人稱代詞：（ ）很可愛",
          answer: "她",
          explanation: "『她』是第三人稱代詞，表示女性。"
        },
        {
          question: "選擇正確的人稱代詞：（ ）很漂亮",
          answer: "它",
          explanation: "『它』是第三人稱代詞，指代事物。"
        },
        {
          question: "選擇正確的人稱代詞：（ ）一起玩",
          answer: "我們",
          explanation: "『我們』是第一人稱複數代詞。"
        },
        {
          question: "選擇正確的人稱代詞：（ ）一起學習",
          answer: "你們",
          explanation: "『你們』是第二人稱複數代詞。"
        },
        {
          question: "選擇正確的人稱代詞：（ ）都很聰明",
          answer: "他們",
          explanation: "『他們』是第三人稱複數代詞。"
        },
        {
          question: "選擇正確的人稱代詞：（ ）都很可愛",
          answer: "她們",
          explanation: "『她們』是第三人稱複數代詞，指代女性。"
        },
        {
          question: "選擇正確的人稱代詞：（ ）都很漂亮",
          answer: "它們",
          explanation: "『它們』是第三人稱複數代詞，指代事物。"
        }
      ]
    },
    {
      title: "多義詞",
      description: "學習多義詞的不同含義，掌握詞語的語境用法",
      sampleQuestions: [
        {
          question: "選擇正確的含義：『打』在『打電話』中的意思是（ ）",
          answer: "撥打",
          explanation: "『打』在這裡是撥打的意思。"
        },
        {
          question: "選擇正確的含義：『打』在『打籃球』中的意思是（ ）",
          answer: "玩",
          explanation: "『打』在這裡是玩的意思。"
        },
        {
          question: "選擇正確的含義：『打』在『打掃』中的意思是（ ）",
          answer: "清潔",
          explanation: "『打』在這裡是清潔的意思。"
        },
        {
          question: "選擇正確的含義：『打』在『打雷』中的意思是（ ）",
          answer: "發出",
          explanation: "『打』在這裡是發出的意思。"
        },
        {
          question: "選擇正確的含義：『打』在『打針』中的意思是（ ）",
          answer: "注射",
          explanation: "『打』在這裡是注射的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看書』中的意思是（ ）",
          answer: "閱讀",
          explanation: "『看』在這裡是閱讀的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看電影』中的意思是（ ）",
          answer: "觀看",
          explanation: "『看』在這裡是觀看的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看病』中的意思是（ ）",
          answer: "診治",
          explanation: "『看』在這裡是診治的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看門』中的意思是（ ）",
          answer: "看守",
          explanation: "『看』在這裡是看守的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看中』中的意思是（ ）",
          answer: "喜歡",
          explanation: "『看』在這裡是喜歡的意思。"
        }
      ]
    },
    {
      title: "直述句",
      description: "學習直述句的結構，掌握直接引語的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的直述句：他說（ ）",
          answer: "我喜歡讀書",
          explanation: "直述句直接引用說話者的原話。"
        },
        {
          question: "選擇正確的直述句：媽媽說（ ）",
          answer: "你要好好讀書",
          explanation: "直述句直接引用說話者的原話。"
        },
        {
          question: "選擇正確的直述句：老師說（ ）",
          answer: "同學們要認真聽課",
          explanation: "直述句直接引用說話者的原話。"
        },
        {
          question: "選擇正確的直述句：爸爸說（ ）",
          answer: "我們一起去公園",
          explanation: "直述句直接引用說話者的原話。"
        },
        {
          question: "選擇正確的直述句：小明說（ ）",
          answer: "我喜歡畫畫",
          explanation: "直述句直接引用說話者的原話。"
        },
        {
          question: "選擇正確的直述句：小華說（ ）",
          answer: "我喜歡唱歌",
          explanation: "直述句直接引用說話者的原話。"
        },
        {
          question: "選擇正確的直述句：姐姐說（ ）",
          answer: "我喜歡跳舞",
          explanation: "直述句直接引用說話者的原話。"
        },
        {
          question: "選擇正確的直述句：弟弟說（ ）",
          answer: "我喜歡玩遊戲",
          explanation: "直述句直接引用說話者的原話。"
        },
        {
          question: "選擇正確的直述句：朋友說（ ）",
          answer: "我們一起玩吧",
          explanation: "直述句直接引用說話者的原話。"
        },
        {
          question: "選擇正確的直述句：同學說（ ）",
          answer: "我們一起學習",
          explanation: "直述句直接引用說話者的原話。"
        }
      ]
    },
    {
      title: "記敘六要素",
      description: "學習記敘文的六個要素，掌握記敘文的寫作方法",
      sampleQuestions: [
        {
          question: "記敘文的六要素中，『時間』是指（ ）",
          answer: "故事發生的時間",
          explanation: "時間是記敘文的重要要素之一。"
        },
        {
          question: "記敘文的六要素中，『地點』是指（ ）",
          answer: "故事發生的地點",
          explanation: "地點是記敘文的重要要素之一。"
        },
        {
          question: "記敘文的六要素中，『人物』是指（ ）",
          answer: "故事中的人物",
          explanation: "人物是記敘文的重要要素之一。"
        },
        {
          question: "記敘文的六要素中，『事件』是指（ ）",
          answer: "故事發生的事件",
          explanation: "事件是記敘文的重要要素之一。"
        },
        {
          question: "記敘文的六要素中，『原因』是指（ ）",
          answer: "事件發生的原因",
          explanation: "原因是記敘文的重要要素之一。"
        },
        {
          question: "記敘文的六要素中，『結果』是指（ ）",
          answer: "事件的結果",
          explanation: "結果是記敘文的重要要素之一。"
        },
        {
          question: "選擇正確的記敘要素：『昨天』屬於（ ）",
          answer: "時間",
          explanation: "『昨天』表示時間。"
        },
        {
          question: "選擇正確的記敘要素：『在公園』屬於（ ）",
          answer: "地點",
          explanation: "『在公園』表示地點。"
        },
        {
          question: "選擇正確的記敘要素：『小明』屬於（ ）",
          answer: "人物",
          explanation: "『小明』是人物。"
        },
        {
          question: "選擇正確的記敘要素：『踢足球』屬於（ ）",
          answer: "事件",
          explanation: "『踢足球』是事件。"
        }
      ]
    },
    {
      title: "結構助詞",
      description: "學習結構助詞的用法，掌握助詞的語法功能",
      sampleQuestions: [
        {
          question: "選擇正確的結構助詞：我（ ）書",
          answer: "的",
          explanation: "『的』是結構助詞，用來連接形容詞和名詞。"
        },
        {
          question: "選擇正確的結構助詞：我喜歡（ ）書",
          answer: "的",
          explanation: "『的』是結構助詞，用來連接動詞和名詞。"
        },
        {
          question: "選擇正確的結構助詞：我（ ）讀書",
          answer: "地",
          explanation: "『地』是結構助詞，用來連接形容詞和動詞。"
        },
        {
          question: "選擇正確的結構助詞：我認真（ ）讀書",
          answer: "地",
          explanation: "『地』是結構助詞，用來連接形容詞和動詞。"
        },
        {
          question: "選擇正確的結構助詞：我（ ）讀書",
          answer: "得",
          explanation: "『得』是結構助詞，用來連接動詞和形容詞。"
        },
        {
          question: "選擇正確的結構助詞：我讀（ ）很好",
          answer: "得",
          explanation: "『得』是結構助詞，用來連接動詞和形容詞。"
        },
        {
          question: "選擇正確的結構助詞：我（ ）書很有趣",
          answer: "的",
          explanation: "『的』是結構助詞，用來連接代詞和名詞。"
        },
        {
          question: "選擇正確的結構助詞：我（ ）書很新",
          answer: "的",
          explanation: "『的』是結構助詞，用來連接代詞和名詞。"
        },
        {
          question: "選擇正確的結構助詞：我（ ）書很厚",
          answer: "的",
          explanation: "『的』是結構助詞，用來連接代詞和名詞。"
        },
        {
          question: "選擇正確的結構助詞：我（ ）書很重",
          answer: "的",
          explanation: "『的』是結構助詞，用來連接代詞和名詞。"
        }
      ]
    }
  ]
};

// Primary 2 Chinese Data - Part 2
export const p2DataPart2 = {
  languageUsage: [
    {
      title: "選詞填充",
      description: "學習選詞填充的方法，掌握詞語的正確用法",
      sampleQuestions: [
        {
          question: "選擇正確的詞語：我（ ）讀書",
          answer: "喜歡",
          explanation: "『喜歡』是動詞，表示愛好。"
        },
        {
          question: "選擇正確的詞語：這本書很（ ）",
          answer: "有趣",
          explanation: "『有趣』是形容詞，表示有意思。"
        },
        {
          question: "選擇正確的詞語：我（ ）畫畫",
          answer: "會",
          explanation: "『會』是動詞，表示能力。"
        },
        {
          question: "選擇正確的詞語：這個蘋果很（ ）",
          answer: "甜",
          explanation: "『甜』是形容詞，表示味道。"
        },
        {
          question: "選擇正確的詞語：我（ ）唱歌",
          answer: "愛",
          explanation: "『愛』是動詞，表示喜愛。"
        },
        {
          question: "選擇正確的詞語：這朵花很（ ）",
          answer: "漂亮",
          explanation: "『漂亮』是形容詞，表示美麗。"
        },
        {
          question: "選擇正確的詞語：我（ ）跳舞",
          answer: "能",
          explanation: "『能』是動詞，表示能力。"
        },
        {
          question: "選擇正確的詞語：這個房間很（ ）",
          answer: "大",
          explanation: "『大』是形容詞，表示大小。"
        },
        {
          question: "選擇正確的詞語：我（ ）游泳",
          answer: "會",
          explanation: "『會』是動詞，表示能力。"
        },
        {
          question: "選擇正確的詞語：這隻貓很（ ）",
          answer: "可愛",
          explanation: "『可愛』是形容詞，表示討人喜歡。"
        }
      ]
    },
    {
      title: "口語和書面語",
      description: "學習口語和書面語的區別，掌握不同語體的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的語體：『吃飯』是（ ）",
          answer: "口語",
          explanation: "『吃飯』是日常口語表達。"
        },
        {
          question: "選擇正確的語體：『用餐』是（ ）",
          answer: "書面語",
          explanation: "『用餐』是正式的書面語表達。"
        },
        {
          question: "選擇正確的語體：『睡覺』是（ ）",
          answer: "口語",
          explanation: "『睡覺』是日常口語表達。"
        },
        {
          question: "選擇正確的語體：『就寢』是（ ）",
          answer: "書面語",
          explanation: "『就寢』是正式的書面語表達。"
        },
        {
          question: "選擇正確的語體：『買東西』是（ ）",
          answer: "口語",
          explanation: "『買東西』是日常口語表達。"
        },
        {
          question: "選擇正確的語體：『購物』是（ ）",
          answer: "書面語",
          explanation: "『購物』是正式的書面語表達。"
        },
        {
          question: "選擇正確的語體：『看電視』是（ ）",
          answer: "口語",
          explanation: "『看電視』是日常口語表達。"
        },
        {
          question: "選擇正確的語體：『觀看電視』是（ ）",
          answer: "書面語",
          explanation: "『觀看電視』是正式的書面語表達。"
        },
        {
          question: "選擇正確的語體：『玩遊戲』是（ ）",
          answer: "口語",
          explanation: "『玩遊戲』是日常口語表達。"
        },
        {
          question: "選擇正確的語體：『進行遊戲』是（ ）",
          answer: "書面語",
          explanation: "『進行遊戲』是正式的書面語表達。"
        }
      ]
    },
    {
      title: "成語填充",
      description: "學習成語的用法，掌握成語的正確搭配",
      sampleQuestions: [
        {
          question: "選擇正確的成語：他學習很認真，（ ）",
          answer: "一絲不苟",
          explanation: "『一絲不苟』形容做事認真仔細。"
        },
        {
          question: "選擇正確的成語：他跑步很快，（ ）",
          answer: "健步如飛",
          explanation: "『健步如飛』形容走路很快。"
        },
        {
          question: "選擇正確的成語：他唱歌很好聽，（ ）",
          answer: "悅耳動聽",
          explanation: "『悅耳動聽』形容聲音好聽。"
        },
        {
          question: "選擇正確的成語：他畫畫很漂亮，（ ）",
          answer: "栩栩如生",
          explanation: "『栩栩如生』形容畫得很逼真。"
        },
        {
          question: "選擇正確的成語：他跳舞很優美，（ ）",
          answer: "翩翩起舞",
          explanation: "『翩翩起舞』形容跳舞優美。"
        },
        {
          question: "選擇正確的成語：他寫字很工整，（ ）",
          answer: "工工整整",
          explanation: "『工工整整』形容字寫得很整齊。"
        },
        {
          question: "選擇正確的成語：他說話很清楚，（ ）",
          answer: "清清楚楚",
          explanation: "『清清楚楚』形容說話清楚。"
        },
        {
          question: "選擇正確的成語：他做事很仔細，（ ）",
          answer: "仔仔細細",
          explanation: "『仔仔細細』形容做事仔細。"
        },
        {
          question: "選擇正確的成語：他讀書很專心，（ ）",
          answer: "專心致志",
          explanation: "『專心致志』形容專心讀書。"
        },
        {
          question: "選擇正確的成語：他工作很努力，（ ）",
          answer: "勤勤懇懇",
          explanation: "『勤勤懇懇』形容工作努力。"
        }
      ]
    },
    {
      title: "肯定句",
      description: "學習肯定句的結構，掌握肯定句的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的肯定句：我（ ）讀書",
          answer: "喜歡",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：他（ ）聰明",
          answer: "很",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：她（ ）可愛",
          answer: "很",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：這本書（ ）有趣",
          answer: "很",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：這個蘋果（ ）甜",
          answer: "很",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：我（ ）畫畫",
          answer: "會",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：他（ ）唱歌",
          answer: "能",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：她（ ）跳舞",
          answer: "會",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：我（ ）游泳",
          answer: "會",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：他（ ）跑步",
          answer: "能",
          explanation: "肯定句表示肯定的意思。"
        }
      ]
    },
    {
      title: "配詞完句",
      description: "學習配詞完句的方法，掌握句子的完整表達",
      sampleQuestions: [
        {
          question: "選擇正確的詞語完成句子：我喜歡（ ）",
          answer: "讀書",
          explanation: "『讀書』是動賓結構，符合句子語法。"
        },
        {
          question: "選擇正確的詞語完成句子：他喜歡（ ）",
          answer: "畫畫",
          explanation: "『畫畫』是動賓結構，符合句子語法。"
        },
        {
          question: "選擇正確的詞語完成句子：她喜歡（ ）",
          answer: "唱歌",
          explanation: "『唱歌』是動賓結構，符合句子語法。"
        },
        {
          question: "選擇正確的詞語完成句子：我喜歡（ ）",
          answer: "跳舞",
          explanation: "『跳舞』是動賓結構，符合句子語法。"
        },
        {
          question: "選擇正確的詞語完成句子：他喜歡（ ）",
          answer: "游泳",
          explanation: "『游泳』是動詞，符合句子語法。"
        },
        {
          question: "選擇正確的詞語完成句子：她喜歡（ ）",
          answer: "跑步",
          explanation: "『跑步』是動賓結構，符合句子語法。"
        },
        {
          question: "選擇正確的詞語完成句子：我喜歡（ ）",
          answer: "玩遊戲",
          explanation: "『玩遊戲』是動賓結構，符合句子語法。"
        },
        {
          question: "選擇正確的詞語完成句子：他喜歡（ ）",
          answer: "看電視",
          explanation: "『看電視』是動賓結構，符合句子語法。"
        },
        {
          question: "選擇正確的詞語完成句子：她喜歡（ ）",
          answer: "聽音樂",
          explanation: "『聽音樂』是動賓結構，符合句子語法。"
        },
        {
          question: "選擇正確的詞語完成句子：我喜歡（ ）",
          answer: "吃蘋果",
          explanation: "『吃蘋果』是動賓結構，符合句子語法。"
        }
      ]
    }
  ]
}; 